/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.9.29",
    versionName: "0.7.0-nightly.2026.9.29",
    versionChannel: "nightly",
    buildDate: "2026-09-29T00:16:48.143Z",
    commitHash: "af6e3e058bdc027ea41fbc234e2ce73cc2ba103b",
};
